import React, { useCallback, useState } from 'react';
import { AdBannerPlaceholder } from 'shared/components/AdBannerPlaceholder';
import { AdfoxBanner } from 'shared/components/AdfoxBanner';
import { OFFER_CARD_DESKTOP_CARD_ADFOX_PLACEMENTS } from 'shared/constants/adfoxPlacements';
import { AdBannerMicrofrontend } from 'shared/containers/AdBannerMicrofrontend';
import { AdfoxContextProvider } from 'shared/context/AdfoxContext';
import { useAdBannerMicrofrontendEnabled } from 'shared/utils/adfox';

const PLACEMENT = OFFER_CARD_DESKTOP_CARD_ADFOX_PLACEMENTS.footer;

export const TgbBottomBannersContainer: React.FC = () => {
  const [isClosed, setIsClosed] = useState(false);
  const isMicrofrontendEnabled = useAdBannerMicrofrontendEnabled();
  const handleClose = useCallback(() => setIsClosed(true), []);

  if (isClosed) {
    return null;
  }

  return (
    <AdfoxContextProvider
      bannerPlace={PLACEMENT.bannerPlace}
      size={PLACEMENT.sizes}
      pParams={PLACEMENT.pParams}
      postViewAnalyticsData={PLACEMENT.postViewAnalyticsData}
    >
      {isMicrofrontendEnabled ? (
        <AdBannerPlaceholder sizes={PLACEMENT.sizes} testId="AdBannerFooter">
          <AdBannerMicrofrontend onClose={handleClose} />
        </AdBannerPlaceholder>
      ) : (
        <AdfoxBanner />
      )}
    </AdfoxContextProvider>
  );
};
